// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sanstha-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 20px 24px;
}

.filter-search {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--cream);
  border: 1.5px solid rgba(200,134,10,0.2);
  border-radius: 10px;
  padding: 0 16px;
  min-width: 220px;
}

.search-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

.filter-search input {
  border: none;
  background: transparent;
  padding: 12px 0;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: var(--text-dark);
  width: 100%;
  outline: none;
}


.verified-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--text-mid);
  white-space: nowrap;
}

.verified-toggle input {
  width: 16px;
  height: 16px;
  accent-color: var(--gold);
  cursor: pointer;
}

.sanstha-count {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-bottom: 24px;
}

.sanstha-count strong {
  color: var(--gold-dark);
}

.sanstha-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 40px;
}

.sanstha-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sanstha-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sanstha-icon {
  font-size: 2rem;
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, rgba(200,134,10,0.1), rgba(196,72,10,0.05));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid rgba(200,134,10,0.15);
}

.verified-badge {
  background: linear-gradient(135deg, #4A6E2A, #6A8E4A);
  color: var(--white);
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  letter-spacing: 0.5px;
}

.sanstha-name {
  font-size: 0.95rem;
  color: var(--brown);
  line-height: 1.4;
}

.sanstha-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sanstha-meta span {
  font-size: 0.8rem;
  color: var(--text-light);
}

.sanstha-activities {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.activity-tag {
  font-size: 0.72rem;
  padding: 3px 10px;
  background: rgba(200,134,10,0.1);
  color: var(--gold-dark);
  border-radius: 20px;
  font-weight: 500;
}

.sanstha-actions {
  display: flex;
  gap: 10px;
  margin-top: auto;
  padding-top: 8px;
}

.no-results {
  text-align: center;
  padding: 80px 0;
  color: var(--text-light);
}

.no-results h3 {
  margin: 12px 0 8px;
  color: var(--text-mid);
}

.sanstha-cta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  background: linear-gradient(135deg, rgba(200,134,10,0.06), rgba(196,72,10,0.04));
  border: 1.5px solid rgba(200,134,10,0.2);
}

.sanstha-cta h3 {
  font-size: 1.1rem;
  margin-bottom: 4px;
}

.sanstha-cta p {
  font-size: 0.88rem;
  color: var(--text-mid);
}

@media (max-width: 900px) {
  .sanstha-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 560px) {
  .sanstha-grid { grid-template-columns: 1fr; }
  .sanstha-filters { flex-direction: column; align-items: stretch; }
  .filter-search { min-width: unset; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Sanstha.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gFAAgF;EAChF,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB,qCAAqC,EAAE;AACzD;;AAEA;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,mBAAmB,sBAAsB,EAAE,oBAAoB,EAAE;EACjE,iBAAiB,gBAAgB,EAAE;AACrC","sourcesContent":[".sanstha-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  padding: 20px 24px;\n}\n\n.filter-search {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--cream);\n  border: 1.5px solid rgba(200,134,10,0.2);\n  border-radius: 10px;\n  padding: 0 16px;\n  min-width: 220px;\n}\n\n.search-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.filter-search input {\n  border: none;\n  background: transparent;\n  padding: 12px 0;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  width: 100%;\n  outline: none;\n}\n\n\n.verified-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: var(--text-mid);\n  white-space: nowrap;\n}\n\n.verified-toggle input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--gold);\n  cursor: pointer;\n}\n\n.sanstha-count {\n  font-size: 0.9rem;\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n.sanstha-count strong {\n  color: var(--gold-dark);\n}\n\n.sanstha-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n.sanstha-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sanstha-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sanstha-icon {\n  font-size: 2rem;\n  width: 52px;\n  height: 52px;\n  background: linear-gradient(135deg, rgba(200,134,10,0.1), rgba(196,72,10,0.05));\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid rgba(200,134,10,0.15);\n}\n\n.verified-badge {\n  background: linear-gradient(135deg, #4A6E2A, #6A8E4A);\n  color: var(--white);\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 20px;\n  letter-spacing: 0.5px;\n}\n\n.sanstha-name {\n  font-size: 0.95rem;\n  color: var(--brown);\n  line-height: 1.4;\n}\n\n.sanstha-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sanstha-meta span {\n  font-size: 0.8rem;\n  color: var(--text-light);\n}\n\n.sanstha-activities {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.activity-tag {\n  font-size: 0.72rem;\n  padding: 3px 10px;\n  background: rgba(200,134,10,0.1);\n  color: var(--gold-dark);\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n.sanstha-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 8px;\n}\n\n.no-results {\n  text-align: center;\n  padding: 80px 0;\n  color: var(--text-light);\n}\n\n.no-results h3 {\n  margin: 12px 0 8px;\n  color: var(--text-mid);\n}\n\n.sanstha-cta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n  background: linear-gradient(135deg, rgba(200,134,10,0.06), rgba(196,72,10,0.04));\n  border: 1.5px solid rgba(200,134,10,0.2);\n}\n\n.sanstha-cta h3 {\n  font-size: 1.1rem;\n  margin-bottom: 4px;\n}\n\n.sanstha-cta p {\n  font-size: 0.88rem;\n  color: var(--text-mid);\n}\n\n@media (max-width: 900px) {\n  .sanstha-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 560px) {\n  .sanstha-grid { grid-template-columns: 1fr; }\n  .sanstha-filters { flex-direction: column; align-items: stretch; }\n  .filter-search { min-width: unset; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
